import React from 'react';

export const IconFB = () => (
  <svg
    width="9"
    height="16"
    viewBox="0 0 9 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 6H9V9H6V16H3V9H0V6H3V4.745C3 3.556 3.374 2.054 4.118 1.233C4.862 0.41 5.791 0 6.904 0H9V3H6.9C6.402 3 6 3.402 6 3.899V6Z"
      fill="#667085"
    />
  </svg>
);
